import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-remove-brochure-dialog',
  templateUrl: './remove-brochure-dialog.component.html',
  styleUrls: ['./remove-brochure-dialog.component.scss']
})
export class RemoveBrochureDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<RemoveBrochureDialogComponent>,

    @Inject(MAT_DIALOG_DATA) public data: {
      id: string,
      name: string
    },
  ) {}

  onConfirm(id: string) {
    this.dialogRef.close({ id: id });
  }
}
